import { Box } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { CustomEvent, Map } from "schemas/functions";

import StyledTextField from "components/Styled/TextField";
import DraftLoader from "features/Auth/Onboarding/EmailBrandForm/DraftLoader";
import styles from "features/Auth/Onboarding/styles";
import { makeDeepCopy } from "utils/updateLocalState";

interface StandOutFormProps {
  onboardingForm: Map;
  setOnboardingForm: Dispatch<SetStateAction<Map>>;
  loading?: boolean;
}

const StandOutForm = ({
  onboardingForm,
  setOnboardingForm,
  loading = false,
}: StandOutFormProps) => {
  const handleChange = (e: CustomEvent) => {
    const { name, value } = e.target;
    const copy = makeDeepCopy(onboardingForm);
    copy[name] = value;
    setOnboardingForm(copy);
  };

  return (
    <>
      {loading && (
        <Box sx={styles.templateWrapper}>
          <Box sx={styles.loaderWrapper}>
            <DraftLoader />
          </Box>
        </Box>
      )}

      {!loading && (
        <StyledTextField
          label="What makes you stand out?"
          fullWidth
          name="standsOutDescription"
          multiline
          minRows={2}
          onChange={handleChange}
          value={onboardingForm?.standsOutDescription || ""}
          styles={{ mb: 2 }}
          placeholder="My background in skincare chemistry lets me explain products in a way viewers actually trust..."
        />
      )}
    </>
  );
};

export default StandOutForm;
